import { render, staticRenderFns } from "./formularioPreeclampsia.vue?vue&type=template&id=b0600daa&scoped=true"
import script from "./formularioPreeclampsia.vue?vue&type=script&lang=js"
export * from "./formularioPreeclampsia.vue?vue&type=script&lang=js"
import style0 from "./formularioPreeclampsia.vue?vue&type=style&index=0&id=b0600daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0600daa",
  null
  
)

export default component.exports